import { CalendarToday, TrendingUp } from '@mui/icons-material';
import { Box, Paper, Tab, Tabs } from '@mui/material';
import React from 'react';
import DailyStatsChart from './DailyStatsChart';
import MonthlyStatsChart from './MonthlyStatsChart';

export default function ChartSection({
  chartView,
  onChartViewChange,
  chartData,
  dailyChartData,
  dailyData,
  loading,
  selectedYear,
  selectedDailyYear,
  selectedDailyMonth,
  availableYears,
  availableMonths,
  onYearChange,
  onDailyYearChange,
  onDailyMonthChange,
  ytdPackageTotal,
  ytdShipmentTotal
}) {
  return (
    <Box sx={{ height: '100%' }}>
      <Paper sx={{ mb: 3 }}>
        <Tabs
          value={chartView}
          onChange={onChartViewChange}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
          variant="fullWidth"
        >
          <Tab
            label="Monthly Trend"
            icon={<TrendingUp />}
            iconPosition="start"
            sx={{ minHeight: 64, fontSize: '0.95rem' }}
          />
          <Tab
            label="Daily Trend"
            icon={<CalendarToday />}
            iconPosition="start"
            sx={{ minHeight: 64, fontSize: '0.95rem' }}
          />
        </Tabs>
      </Paper>
      <Box sx={{ height: 'calc(100% - 140px)' }}>
        {chartView === 0 && (
          <MonthlyStatsChart
            chartData={chartData}
            loading={loading}
            selectedYear={selectedYear}
            availableYears={availableYears}
            onYearChange={onYearChange}
            ytdPackageTotal={ytdPackageTotal}
            ytdShipmentTotal={ytdShipmentTotal}
          />
        )}
        {chartView === 1 && (
          <DailyStatsChart
            dailyChartData={dailyChartData}
            dailyData={dailyData}
            loading={loading}
            selectedDailyYear={selectedDailyYear}
            selectedDailyMonth={selectedDailyMonth}
            availableYears={availableYears}
            availableMonths={availableMonths}
            onDailyYearChange={onDailyYearChange}
            onDailyMonthChange={onDailyMonthChange}
          />
        )}
      </Box>
    </Box>
  );
}
